<template>
  <div>
    <div ref="scrollView" class="scroll-view" @scroll="onScroll">
      <slot></slot>
    </div>
    <div class="_scroll-bar" v-show="visible">
      <div class="track" :style="{ width: trackwidth + 'px' }">
        <div class="thumb" :style="{ width: thumb.width + 'px', transform: `translateX(${thumb.position}%)`}" />
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/common'
export default {
  props: {
    trackWidth: {
      type: [Number, String],
      default: 60
    }
  },
  data() {
    return {
      thumb: {
        position: 0,
        width: 0
      },
      visible: false,
      trackwidth: utils.rem2px(this.trackWidth, false)
    }
  },
  mounted() {
    this.updateThumbWidth()
  },
  methods: {
    onScroll(e) {
      const { scrollLeft, scrollWidth } = e.target
      const scale = (this.trackwidth - this.thumb.width) / this.thumb.width
      const position = Math.ceil(scrollLeft / (scrollWidth - this.scrollViewWidth) * scale * 100)
      this.thumb.position = position
    },
    updateThumbWidth() {
      this.$nextTick(() => this.updateThumb())
    },
    updateThumb() {
      const node = this.$refs.scrollView
      const scale = node.offsetWidth / node.scrollWidth
      const thumb = {
        minWidth: this.trackwidth * 0.2,
        width: this.trackwidth * scale
      }
      this.scrollViewWidth = node.offsetWidth
      this.thumb.width = Math.max(thumb.width, thumb.minWidth)
      this.visible = node.scrollWidth > Math.ceil(node.offsetWidth)
    }
  }
}
</script>

<style lang="less" scoped>
.scroll-view {
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
.scroll-view::-webkit-scrollbar {
  display: none;
}
._scroll-bar {
  text-align: center;
  font-size: 0;
  overflow: hidden;
  margin-top: 10px;
  .track {
    display: inline-block;
    width: 60px;
    height: 6px;
    background: #f2f2f2;
    border-radius: 3px;
    text-align: left;
    overflow: hidden;
  }
  .thumb {
    display: inline-block;
    height: 6px;
    border-radius: 6px;
    background: linear-gradient(180deg,rgba(255,53,27,1) 0%,rgba(240,38,16,1) 100%);
  }
}
</style>
